import {useState, useRef} from "react";
import {ImperativePanelHandle} from "react-resizable-panels";

export enum PanelState {
  CLOSED,
  COLLAPSED,
  EXPANDED,
}
export const usePanelControl = (
  initialState: PanelState = PanelState.CLOSED,
  minSize: number,
  maxSize: number,
) => {
  const panelRef = useRef<ImperativePanelHandle>(null);
  const [panelState, setPanelState] = useState<PanelState>(initialState);
  const resizePanel = (size: PanelState) => {
    const panel = panelRef.current;
    if (panel) {
      switch (size) {
        case PanelState.CLOSED:
          setPanelState(PanelState.CLOSED);
          break;
        case PanelState.COLLAPSED:
          panel.collapse();
          setPanelState(PanelState.COLLAPSED);
          break;
        case PanelState.EXPANDED:
          setPanelState(PanelState.EXPANDED);
          panel.resize(maxSize);
          break;
      }
    }
  };

  return {
    panelRef,
    panelState,
    resizePanel,
  };
};
